import CompanyDashboard from './CompanyDashboard';
// CompanyReports is the same as CompanyDashboard for now
export default CompanyDashboard;
